
export default {
    name: 'tarif-admission',
    components: {},
    props: {
        assurance_id: Number,
        fields: Array,
        assurance_select: Object,
        editing_admission_tarif_data: Object
    },
    data() {
        return {
            is_printing: false,
            admission_is_loading: true,
            admission_is_empty: false,
            is_error_load: false,

			admission_filter: "",
			perPage: 20,
			print_per_page: -1,
			currentPage: 1,
        }
    },

    watch: {
        assurance_select() {
            const data = {
                assurance_id: this.assurance_select.compagnie_id,
                data_type: 'admission'
            }
            this.getListeAdmission(data)
        },

        editing_admission_tarif_data() {
            this.saveTarifAdmission()
        }
    },

    computed: {
        tarif_admissions() {
            return this.$store.getters["tarif_admissions"];
        },

        admission_length() {
            return this.tarif_admissions.length;
        },
    },

    mounted() {
        const data = {
            assurance_id: 0,
            data_type: 'admission'
        }
        this.getListeAdmission(data)
    },

    methods: {
        getListeAdmission(data) {
            this.admission_is_loading = true

            this.$store.dispatch('getTarificationTypeAdmission', data).then(() => {
                console.log(this.tarif_admissions);
                if (this.tarif_admissions.length > 0) {
                    this.admission_is_empty = false
                } else {
                    this.admission_is_empty = true
                }
                this.admission_is_loading = false
            }).catch(() => {
                this.admission_is_loading = false
                this.is_error_load = true
            })
        },

        edit(data, type_prestation) {
            const tarif_data = {
                data: data,
                type_prestation: type_prestation
            }
            this.$emit('emitTarifAdmission', tarif_data)
        },

        saveTarifAdmission() {
            this.editing_admission_tarif_data.type_prestation = 'admission'
            this.$store.dispatch("saveTarifTypeAdmission", this.editing_admission_tarif_data).then((response) => {
                if (response.success) {
                    const data = {
                        assurance_id: this.assurance_select.compagnie_id,
                        data_type: 'admission'
                    }
                    this.getListeAdmission(data)

                    this.$emit('emitCloseTarifModal')
                } else {
                    if (response.code == 401) {
                        this.errorToast("Une erreur s'est produite ! Merci de réessayer plustard.")
                    } else if (response.code == 500) {
                        this.errorToast("Une erreur s'est produite !")
                    }
                }
                this.save_loading = false
                this.btn_disable = false
            })
        },

        printTarifAdmission() {
            const data = {
                data_type: 'admission',
                prestations: this.tarif_admissions
            }
            
            this.$emit('emitPrintTarif', data)
        }
    }
}
